export enum NonEvmChain {
  APTOS = "aptos",
}

export enum AptosProtocols {
  TAPP_EXCHANGE = "tappexchange",
  HYPERION = "hyperion",
  THALA = "thala",
  ARIES = "aries",
}

export enum NonEvmChainId {
  APTOS = -1,
}
